import React, { useState } from 'react';
import { Box, Button, Typography, CircularProgress, TextField, MenuItem } from '@material-ui/core';
import useMembershipCatalogs from '../useMembershipCatalogs';

const ChangeMembership = ({ student, loading, onConfirm, disabled, companyTag }) => {
    const [membershipId, setMembershipId] = useState('');
    const [periodSku, setPeriodSku] = useState('');
    const [addonSku, setAddonSku] = useState('');
    const [disabledAddon, setDisabledAddon] = useState(false);

    const [periodOptions, setPeriodOptions] = useState([]);

    // Catálogos de membresía/addon desde el hook COMPARTIDO: la llamada al backend
    // ocurre una sola vez por sesión (caché a nivel de módulo) y se reutiliza aquí
    // y en el alta de usuarios. Como la precarga arranca al entrar a la pantalla de
    // Modificaciones, al abrir este modal los catálogos ya están listos (el selector
    // no aparece vacío). getPeriods carga los plazos de la membresía elegida.
    const { membershipOptions, addonOptions, loadingCatalogs, getPeriods } = useMembershipCatalogs();

    // Load periods when membership changes
    const handleMembershipChange = async (e) => {
        const value = e.target.value;
        setMembershipId(value);
        setPeriodSku('');
        setPeriodOptions([]);

        if (!value) return;

        const period = await getPeriods(value);
        setPeriodOptions(period);
    };

    const handleConfirm = () => {
        if (!periodSku) return;
        const paymentReferenceId = `B2B-${companyTag || 'EMPRESA'}`;
        onConfirm({
            student,
            membershipSku: periodSku,
            addonSkus: addonSku ? [addonSku] : [],
            paymentReferenceId,
        });
    };

    return (
        <Box>
            <Typography variant="body2" color="textSecondary" gutterBottom>
                Seleccione la nueva membresía para <strong>{student.first_name} {student.last_name}</strong>.
            </Typography>

            {/* 1. Membresía */}
            <Box mt={2} maxWidth={400}>
                <TextField
                    select
                    label="Membresía"
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    value={membershipId}
                    onChange={handleMembershipChange}
                    InputLabelProps={{ shrink: true }}
                    disabled={disabled || loading || loadingCatalogs}
                >
                    {membershipOptions.map(opt => (
                        <MenuItem key={opt.id} value={opt.id}>{opt.label}</MenuItem>
                    ))}
                </TextField>
            </Box>

            {/* 2. Plazo (depende de membresía) */}
            <Box mt={2} maxWidth={400}>
                <TextField
                    select
                    label="Plazo"
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    value={periodSku}
                    onChange={(e) => {
                        const value = e.target.value;
                        setPeriodSku(value);
                        // Disable addon for monthly plans
                        if (value.includes('-1M')) {
                            setDisabledAddon(true);
                            setAddonSku('');
                        } else {
                            setDisabledAddon(false);
                        }
                    }}
                    InputLabelProps={{ shrink: true }}
                    disabled={disabled || loading || !membershipId || periodOptions.length === 0}
                >
                    {periodOptions.map(opt => (
                        <MenuItem key={opt.id} value={opt.id}>{opt.label}</MenuItem>
                    ))}
                </TextField>
            </Box>

            {/* 3. Addon (opcional — disabled for monthly plans) */}
            <Box mt={2} maxWidth={400}>
                <TextField
                    select
                    label="Addon (opcional)"
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    value={addonSku}
                    onChange={(e) => setAddonSku(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    disabled={disabled || loading || disabledAddon}
                >
                    {addonOptions.map(opt => (
                        <MenuItem key={opt.id} value={opt.id}>{opt.label}</MenuItem>
                    ))}
                </TextField>
            </Box>

            <Box mt={3}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleConfirm}
                    disabled={disabled || loading || !periodSku}
                    startIcon={loading ? <CircularProgress size={16} /> : null}
                >
                    {loading ? 'Procesando...' : 'Confirmar Cambio'}
                </Button>
            </Box>
        </Box>
    );
};

export default ChangeMembership;
